/**
 * Accepted-payment logos for the checkout payment page. Self-contained inline SVGs
 * (no external requests) for the card schemes Stripe supports plus the wallets and PayPal.
 */

const Wrap = ({ children, title }: { children: React.ReactNode; title: string }) => (
  <span
    title={title}
    className="inline-flex items-center justify-center bg-white border border-gray-200 rounded-md shadow-sm"
    style={{ width: 69, height: 45 }}
  >
    {children}
  </span>
)

export default function PaymentLogos() {
  return (
    <div className="mt-3">
      <p className="text-xs text-gray-500 mb-2">Secure payments — we accept:</p>
      <div className="flex flex-wrap items-center gap-2">
        {/* Visa */}
        <Wrap title="Visa">
          <svg width="51" height="18" viewBox="0 0 48 16" xmlns="http://www.w3.org/2000/svg" aria-label="Visa">
            <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontStyle="italic" fontSize="15" fill="#1A1F71">VISA</text>
          </svg>
        </Wrap>

        {/* Mastercard */}
        <Wrap title="Mastercard">
          <svg width="51" height="33" viewBox="0 0 36 24" xmlns="http://www.w3.org/2000/svg" aria-label="Mastercard">
            <circle cx="14" cy="12" r="9" fill="#EB001B" />
            <circle cx="22" cy="12" r="9" fill="#F79E1B" />
            <path d="M18 5.2a9 9 0 0 0 0 13.6 9 9 0 0 0 0-13.6z" fill="#FF5F00" />
          </svg>
        </Wrap>

        {/* American Express */}
        <Wrap title="American Express">
          <svg width="60" height="39" viewBox="0 0 44 28" xmlns="http://www.w3.org/2000/svg" aria-label="American Express">
            <rect width="44" height="28" rx="3" fill="#2E77BC" />
            <text x="22" y="12" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="7" fill="#fff">AMERICAN</text>
            <text x="22" y="21" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="7" fill="#fff">EXPRESS</text>
          </svg>
        </Wrap>

        {/* Apple Pay */}
        <Wrap title="Apple Pay">
          <svg width="57" height="27" viewBox="0 0 44 20" xmlns="http://www.w3.org/2000/svg" aria-label="Apple Pay">
            <path d="M7.3 4.6c.4-.5.7-1.2.6-1.9-.6 0-1.3.4-1.7.9-.4.4-.7 1.1-.6 1.8.7.1 1.3-.3 1.7-.8zm.6 1c-.9-.1-1.7.5-2.1.5-.4 0-1.1-.5-1.8-.5-.9 0-1.8.5-2.2 1.4-1 1.6-.3 4 .7 5.3.5.6 1 1.3 1.7 1.3.7 0 .9-.4 1.8-.4.8 0 1 .4 1.8.4.7 0 1.2-.6 1.7-1.3.5-.7.7-1.4.7-1.5 0 0-1.4-.5-1.4-2.1 0-1.3 1.1-1.9 1.1-2-.6-.9-1.5-1-1.8-1z" fill="#000" />
            <text x="14" y="14" fontFamily="Arial, sans-serif" fontWeight="600" fontSize="11" fill="#000">Pay</text>
          </svg>
        </Wrap>

        {/* Google Pay */}
        <Wrap title="Google Pay">
          <svg width="60" height="24" viewBox="0 0 48 18" xmlns="http://www.w3.org/2000/svg" aria-label="Google Pay">
            <text x="0" y="14" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="13">
              <tspan fill="#4285F4">G</tspan><tspan fill="#EA4335">o</tspan><tspan fill="#FBBC05">o</tspan><tspan fill="#4285F4">g</tspan><tspan fill="#34A853">l</tspan><tspan fill="#EA4335">e</tspan>
            </text>
            <text x="34" y="14" fontFamily="Arial, sans-serif" fontWeight="600" fontSize="13" fill="#5F6368">Pay</text>
          </svg>
        </Wrap>

        {/* PayPal */}
        <Wrap title="PayPal">
          <svg width="60" height="21" viewBox="0 0 50 16" xmlns="http://www.w3.org/2000/svg" aria-label="PayPal">
            <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontStyle="italic" fontSize="14">
              <tspan fill="#003087">Pay</tspan><tspan fill="#009CDE">Pal</tspan>
            </text>
          </svg>
        </Wrap>
      </div>
    </div>
  )
}
